import { ApiTwoTone, SyncOutlined, WifiOutlined } from "@ant-design/icons";
import { Button, Modal, Select } from "antd";
import { OgnModeDescriptions, OgnModeRadioGroup } from "~/components/flight/OgnModeSelect.jsx";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { $t } from "~/i18n.js";
import { saveOGNmode } from "~/redux/flights/flights.actions.js";

import { AnnuleerButton } from "~/components/buttons/AnnuleerButton.jsx";
import { SaveButton } from "~/components/buttons/SaveButton.jsx";
import { SelectLanguage } from "~/components/profile/selectLanguage.jsx";

// `connected` is managed by useWebsocket (compositions/useWebsocket.js) and passed in from start.jsx
// -1 = connecting, 1 = open, 0 = closed/error
export const LiveFlightConnection = ({ club, dayId, connected }) => {
  const {
    network_online,
    default_flight_cat,
    default_sleep_cat,
    default_tmg_cat,
    ogn_mode,
  } = useSelector((state) => state.flights);

  const dispatch = useDispatch();

  const [showOGNdialog, setShowOGNdialog] = useState(false);
  const [newOGNmode, setNewOGNmode] = useState("manueel"); // manueel, auto
  const [pendingSave, setPendingSave] = useState(false);

  const saveNewMode = async () => {
    setPendingSave(true);
    // Ensure all required properties are present
    const payload = {
      ogn_mode: newOGNmode,
      dag_id: dayId,
      default_flight_cat: newCatLookup.default_flight_cat ?? default_flight_cat,
      default_sleep_cat: newCatLookup.default_sleep_cat ?? default_sleep_cat,
      default_tmg_cat: newCatLookup.default_tmg_cat ?? default_tmg_cat,
    };
    const res = await dispatch(saveOGNmode(payload));
    res && setShowOGNdialog(false);
    setPendingSave(false);
  };

  const onCancel = () => {
    setShowOGNdialog(false);
    setPendingSave(false);
  };

  const flight_cat = club.flight_cat ? club.flight_cat.split(",") : null;
  const sleep_cat = club.sleep_cat ? club.sleep_cat.split(",") : null;
  const tmg_cat = club.tmg_cat ? club.tmg_cat.split(",") : null;

  // Fix newCatLookup to always have the required keys
  const [newCatLookup, setNewCatLookup] = useState({
    default_flight_cat: default_flight_cat ?? '',
    default_sleep_cat: default_sleep_cat ?? '',
    default_tmg_cat: default_tmg_cat ?? '',
  });

  useEffect(
    () =>
      setNewCatLookup({
        default_flight_cat: default_flight_cat ?? '',
        default_sleep_cat: default_sleep_cat ?? '',
        default_tmg_cat: default_tmg_cat ?? '',
      }),
    [default_flight_cat, default_sleep_cat, default_tmg_cat]
  );

  const _selectValue = (categories, key) => (
    <div key={key} className="row" style={{ marginTop: 4 }}>
      <p>
        {$t("Standaard")} {categories[0]}:
      </p>
      <Select
        value={newCatLookup[key]}
        style={{ minWidth: 100, marginLeft: 6 }}
        onChange={(value) => {
          const lookup = { ...newCatLookup };
          lookup[key] = value;
          setNewCatLookup(lookup);
        }}
      >
        {categories.map(
          (value, id) =>
            id > 0 &&
            value !== "other" && (
              <Select.Option key={id} value={value.trim()}>
                {value}
              </Select.Option>
            )
        )}
      </Select>
    </div>
  );

  return (
    <>
      {showOGNdialog && (
        <Modal
          title={$t("Methode van tijdschrijven")}
          open={showOGNdialog}
          width="600px"
          confirmLoading={pendingSave}
          okText={$t("Opslaan")}
          cancelText={$t("Annuleren")}
          onCancel={onCancel}
          footer={[
            <AnnuleerButton key="annuleren" onClick={onCancel} />,
            <SaveButton key="3" onClick={saveNewMode} />,
          ]}
        >
          <SelectLanguage />

          {(flight_cat || sleep_cat || tmg_cat) && (
            <>
              <p className="bold">{$t("Selecteer standaard waardes")}</p>

              <p>
                {$t(
                  "De geselecteerde waarde kun je gedurende de vliegdag aanpassen en zullen bij nieuwe vluchten geselecteerd worden."
                )}
              </p>

              {flight_cat && _selectValue(flight_cat, "default_flight_cat")}
              {sleep_cat && _selectValue(sleep_cat, "default_sleep_cat")}
              {tmg_cat && _selectValue(tmg_cat, "default_tmg_cat")}

              <p className="bold" style={{ marginTop: 24 }}>
                {$t("OGN modus")}
              </p>
            </>
          )}

          <div className="row" style={{ gap: 12 }}>
            <p>{$t("Methode van tijdschrijven")}: </p>
            <OgnModeRadioGroup
              style={{ margin: "12px 0" }}
              value={newOGNmode}
              onChange={(event) => setNewOGNmode(event.target.value)}
            />
          </div>

          <OgnModeDescriptions />

        </Modal>
      )}

      <Button
        size="small"
        className="clickable"
        style={{ display: "flex", alignItems: "center", marginRight: 4 }}
        onClick={() => {
          setNewOGNmode(ogn_mode);
          setPendingSave(false);
          setShowOGNdialog(true);
        }}
      >
        {network_online && connected === -1 && <SyncOutlined spin />}

        {network_online && connected === 1 && (
          <div className="row" style={{ alignItems: "center", marginRight: 6 }}>
            <WifiOutlined style={{ color: "green", marginRight: 4 }} />
            <span className="small">{ogn_mode.replace("_", " ")}</span>
          </div>
        )}

        {(!network_online || connected === 0) && (
          <div className="row" style={{ alignItems: "center", marginRight: 6 }}>
            <ApiTwoTone
              style={{ marginRight: 6 }}
              className="pulse"
              twoToneColor="#E14D52"
            />
            <span className="small">
              {$t("offline")} {!network_online ? "wifi" : ""}
            </span>
          </div>
        )}
      </Button>
    </>
  );
};
